import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { Container } from "react-bootstrap";

//import dummy partner images
import stripe from "../../../assets/images/partners/stripe.svg";
import affirm from "../../../assets/images/partners/affirm.svg";
import wish from "../../../assets/images/partners/wish.svg";
import himshers from "../../../assets/images/partners/himshers.svg";
import faire from "../../../assets/images/partners/faire.svg";

const PartnerItem = ({ logo, name }) => {
  return (
    <div className="partner-item">
      <img alt={name} src={logo} />
    </div>
  );
};
const Partners = ({ partners }) => {
  return (
    <div className="partners">
      <Container>
        <h1 className="title">Leave your business in good hands.</h1>
        <p className="partner-section-text">
          We’re a proven group of e-commerce experts and operators who have
          teamed up with the early investors and founders of some of the biggest
          names in the industry.
        </p>
        <div className="partners-list">
          {partners &&
            partners.map((item) => <PartnerItem key={item.id} {...item} />)}
        </div>
        <div className="partner-section-text mb-10">
          OpenStore’s unique approach combines our seasoned expertise in
          e-commerce with the best of data science and machine learning. We’re
          investing in the future of e-commerce, and we believe that future
          begins with founders ambitious enough to build it — you.
        </div>
        <a href="#/" className="join_us">
          Join our family of founders →
        </a>
      </Container>
    </div>
  );
};

Partners.propTypes = {
  partners: PropTypes.array,
};
Partners.defaultProps = {
  partners: [
    { id: 1, name: "stripe", logo: stripe },
    { id: 2, name: "affirm", logo: affirm },
    { id: 3, name: "wish", logo: wish },
    { id: 4, name: "himsher", logo: himshers },
    { id: 5, name: "faire", logo: faire },
  ],
};
export default Partners;
